import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { catchError } from '../../helpers/catch-error'
import { useNavigate } from "react-router-dom";



const BookKeeping = ({ work_order, onWorkOrderChange , readOnly=false}) => {
    const navigate = useNavigate();
    const [editMode, setEditMode] = useState(false);
    const [isBtn, setIsBtn] = useState(false);
    const [addMode, setAddMode] = useState(false);
    const [facilityPayment, setFacilityPayment] = useState(null);
  
    const [facilityPaymentAdd, setFacilityPaymentAdd] = useState(null);
    const [inputError, setInputError] = useState(false);



  

    useEffect(() => {
       
        if (work_order?.work_order_id > 0 && work_order?.status >= 4) {
            getBookKeeping();
  
        }


    }, [work_order?.work_order_id, work_order?.status]);

   


    const getBookKeeping = async () => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-facility-payment-by-work-order-id/"+ work_order?.work_order_id, 
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setFacilityPayment(response?.data?.facilityPayment)



                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {
                catchError(error,navigate)
            });


    }


    const addFacilityPayment = async () => {

        setFacilityPaymentAdd(null);
        setAddMode(true);

    }


    const saveFacilityPayment = async (e) => {


        setIsBtn(true);
        let error_flag = false;


        if ( !facilityPaymentAdd?.check_reference_number || !facilityPaymentAdd?.facility_payment?.toString().match(/^[0-9]*\.\d{1,2}$/)) {

            error_flag = true;
        }

        if (error_flag) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var facility_payment_info = {
                work_order_id: work_order?.work_order_id,
                facility_payment: facilityPaymentAdd?.facility_payment,
                check_reference_number: facilityPaymentAdd?.check_reference_number,
                facility_payment_notes: facilityPaymentAdd?.facility_payment_notes,
               
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-facility-payment", facility_payment_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    facility_payment_info.facility_payment_id = response?.data?.facility_payment_id;
                    setFacilityPayment(facility_payment_info);
                    setEditMode(false)
                    setAddMode(false)

                } else {

                    Swal.fire({ icon: "error", title: "Book Keeping Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                
                setIsBtn(false);
                catchError(error,navigate)
            });

        }


    }



    const updateFacilityPayment = async (e) => {

        setIsBtn(true);
        let error_flag = false;

        const { facility_payment, check_reference_number } = facilityPayment;
        if ( !check_reference_number || !facility_payment.toString().match(/^[0-9]*\.\d{1,2}$/) ) {

            error_flag = true;
        }

        if (error_flag) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var facility_payment_info = {
                work_order_id: work_order?.work_order_id,
                facility_payment_id: facilityPayment?.facility_payment_id,
                facility_payment: facilityPayment?.facility_payment,
                check_reference_number: facilityPayment?.check_reference_number,
                facility_payment_notes: facilityPayment?.facility_payment_notes,
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-facility-payment", facility_payment_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setFacilityPayment(facility_payment_info);
                    setEditMode(false)
                    setAddMode(false)


                } else {

                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

               
                setIsBtn(false);
                catchError(error,navigate)
            });

        }


    }

    const editFacilityPayment = async()=>{


        setEditMode(true); 
         

    }


    return (
        <>


            {(work_order?.status >= 4) &&

                <>
                    <div className="row mt-2 mx-0 sub-heading">
                        <div className="col py-1">

                            <div className="py-2 fw-bold text-dark">BOOK-KEEPING</div>

                        </div>
                        {work_order?.status<7 && !readOnly &&

                        <div className="col py-1 text-end">

                            {addMode ? 
                            <>
                                    <button onClick={() => saveFacilityPayment()} className="btn btn-sm  btn-success me-1 mt-1" type="button" disabled={isBtn?true:false} >{isBtn?<><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></>:"SAVE"}</button>
                                    <button onClick={() => { setAddMode(false); setFacilityPaymentAdd(null); }} className="btn btn-sm  btn-warning me-1 mt-1" type="button">CANCEL SAVE</button>
                                    </>
                                :
                                <>
                                    {editMode ?
                                        <>
                                            <button onClick={() => updateFacilityPayment()} className="btn btn-sm  btn-success me-1 mt-1" type="button" disabled={isBtn?true:false} >{isBtn?<><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></>:"UPDATE"}</button>
                                            <button onClick={() => setEditMode(false)} className="btn btn-sm   btn-warning me-1 mt-1" type="button">CANCEL UPDATE</button>
                                        </>

                                        :
                                        <>
                                            {(facilityPayment?.facility_payment_id > 0) ?
                                                <button onClick={() => {editFacilityPayment()}} className="btn btn-sm    btn-success me-1 mt-1" type="button">Edit</button>
                                              :
                                                <button onClick={() => addFacilityPayment()} className="btn btn-sm    btn-success me-1 mt-1" type="button">Add</button>
                                            }
                                        </>
                                    }
                                </>
                            }

                        </div>
}

                    </div>

                    {(addMode) ?
                        <>


                            <form method="post" action="" encType="multipart/form-data" name="updates" id="updates">
                                <div className="row px-3 py-2 gx-2 ">
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">Payment Amount(USD):dd.cc</label>
                                        <input name="facility_payment" className="form-control"
                                            value={facilityPaymentAdd?.facility_payment}
                                            onChange={(e) =>
                                                setFacilityPaymentAdd({ ...facilityPaymentAdd, facility_payment: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!facilityPaymentAdd?.facility_payment.toString().match(/^[0-9]*\.\d{1,2}$/)) && (
                                                <span className="text-danger">Enter facility fee in dd.cc format</span>
                                            )}
                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">Check/Reference Number*</label>

                                        <input name="check_reference_number" className="form-control"
                                            value={facilityPaymentAdd?.check_reference_number}
                                            onChange={(e) =>
                                                setFacilityPaymentAdd({ ...facilityPaymentAdd, check_reference_number: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!facilityPaymentAdd?.check_reference_number) && (
                                                <span className="text-danger">Enter Check/Reference Number</span>
                                            )}


                                    </div>
                                
                                    <div className="col-md-6 col-sm-12">
                                        <label htmlFor="facility_payment_notes">PAYMENT NOTES</label>
                                        <textarea rows="1" name="facility_payment_notes" id="facility_payment_notes"
                                            className="form-control"
                                            onChange={(e) =>
                                                setFacilityPaymentAdd({ ...facilityPaymentAdd, facility_payment_notes: e.target.value })
                                            }

                                        >
                                            {facilityPaymentAdd?.facility_payment_notes}
                                        </textarea>


                                    </div>
                                  

                                </div>

                           

                            </form>

                        </>
                        :
                        <>
                            {(editMode) ?
                                <>

                              
    
<form method="post" action="" encType="multipart/form-data" name="updates" id="updates">
                                <div className="row px-3 py-2 gx-2 ">
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">Payment Amount(USD):dd.cc</label>
                                        <input name="facility_payment" className="form-control"
                                            value={facilityPayment?.facility_payment}
                                            onChange={(e) =>
                                                setFacilityPayment({ ...facilityPayment, facility_payment: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!facilityPayment?.facility_payment.toString().match(/^[0-9]*\.\d{1,2}$/)) && (
                                                <span className="text-danger">Enter facility fee in dd.cc format</span>
                                            )}
                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">Check/Reference Number*</label>

                                        <input name="check_reference_number" className="form-control"
                                            value={facilityPayment?.check_reference_number}
                                            onChange={(e) =>
                                                setFacilityPayment({ ...facilityPayment, check_reference_number: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!facilityPayment?.check_reference_number ) && (
                                                <span className="text-danger">Enter Check/Reference Number</span>
                                            )}


                                    </div>
                                  
                               
                                    <div className="col-md-6 col-sm-12">
                                        <label htmlFor="facility_payment_notes">PAYMENT NOTES</label>
                                        <textarea rows="1" name="facility_payment_notes" id="facility_payment_notes"
                                            className="form-control"
                                            onChange={(e) =>
                                                setFacilityPayment({ ...facilityPayment, facility_payment_notes: e.target.value })
                                            }

                                        >
                                            {facilityPayment?.facility_payment_notes}
                                        </textarea>


                                    </div>
                                  

                                </div>

                             

                            </form>

    
                            </>
                                :
                                <>
                                    {(facilityPayment?.facility_payment_id > 0) ?
                                        <>

                                <div className="row px-3 py-2 gx-2 ">
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">Payment Amount(USD): </label>
                                        <label className="field-info" >{parseFloat(facilityPayment?.facility_payment).toFixed(2)}</label>
                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">Check/Reference Number:</label>

                                        <label className="field-info" >{facilityPayment?.check_reference_number}</label>


                                    </div>
                                  
                                    <div className="col-md-6 col-sm-12">
                                        <label htmlFor="facility_payment_notes">PAYMENT NOTES:</label>
                                        <label className="field-info" >{facilityPayment?.facility_payment_notes?facilityPayment?.facility_payment_notes:""}</label>



                                    </div>
                                  

                                </div>

                              
    

                                    </>
                                        :
                                        <div className="row " >

                                            <div className="col-xl-12 col-lg-12 py-4 px-3" >

                                                <h5>No book keeping has been generated yet.</h5>

                                            </div>

                                        </div>
                                    }
                                </>
                            }

                        </>
                    }


                </>
            }
        </>
    )

}
export default BookKeeping;